const url = new URL(window.location.href);
let domain,
  subDomain = "";

if (url.hostname.split(".").length === 3) {
  domain = url.hostname.substring(
    url.hostname.indexOf(".") + 1,
    url.hostname.length
  );
  if (
    url.hostname.split(".").length > 1 &&
    url.hostname.split(".")[0].length > 3
  ) {
    subDomain = url.hostname.substring(0, url.hostname.indexOf("."));
  }
} else {
  domain = url.hostname;
}

const devVersion = "1.0.0";
const stagingVersion = "1.0.0";
const prodVersion = "1.0.0";
let version = "";

if (process.env.REACT_APP_ENV === "development") {
  version = devVersion;
} else if (process.env.REACT_APP_ENV === "staging") {
  version = stagingVersion;
} else if (process.env.REACT_APP_ENV === "production") {
  version = prodVersion;
} else {
  version = devVersion;
}

const mainUrl = "https://app.lusoft.io";

const config = {
  version: version,
  baseUrl: process.env.REACT_APP_BASE_URL || "/",
  domain: domain,
  subDomain: subDomain,
  clientId: process.env.REACT_APP_CLIENT_ID,
  launchingDate: "2024-01-15T11:00:00+05:30",
  signInUrl: `${mainUrl}/sign-in`,
  signUpUrl: `${mainUrl}/sign-up`,
  supportEmail: "support@lusoft.in",
  googleAnalytics: process.env.REACT_APP_GA_TRACKING_ID,
};

export default config;
